const units = ["g", "dkg", "kg", "ml", "dl", "l", "db"] as const;
type Unit = (typeof units)[number];

/**
 * Represents an amount of something with a specific unit.
 */
type Amount = {
    amount: number;
    unit: Unit;
};

/**
 * Represents a sale of lemonade.
 */
interface Sale {
    /**
     * Timestamp of the sale.
     */
    date: Date;
    /**
     * Amount of lemonade sold, measured in dl.
     */
    amount: number;
    /**
     * Total price of the sale.
     */
    price: number;
    /**
     * Name of the product sold.
     */
    lemonade: Lemonade;
}

/**
 * Represents a single type of lemonade.
 */
interface Lemonade {
    /**
     * Name of the lemonade.
     */
    name: string;
    /**
     * Ingredients of the lemonade for a single serving.
     * Each ingredient has a name, amount, and unit of measurement.
     */
    ingredients: {
        /**
         * Name of the ingredient.
         */
        name: string;
        /**
         * Amount of the ingredient.
         */
        amount: Amount;
    }[];
    /**
     * Price of the lemonade per serving.
     */
    price: number;
}

/**
 * Represents a purchase of ingredients for making lemonade.
 */
interface Purchase {
    /**
     * Timestamp of the purchase.
     */
    date: Date;
    /**
     * Amount of ingredients purchased.
     */
    amount: Amount;
    /**
     * Amount of money spent on the purchase.
     */
    price: number;
    /**
     * Name of the product purchased.
     */
    product: string;
}

export type { Unit, Amount, Sale, Lemonade, Purchase };
export { units };
